'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./PageContent.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Lib
var PageContent = function PageContent(_ref) {
    var children = _ref.children,
        className = _ref.className;
    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('PageContent', className) },
        children
    );
};

// Styles


PageContent.propTypes = {
    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]).isRequired,
    className: _propTypes2.default.string
};

exports.default = PageContent;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/modal/PageContent.js
// module id = 1917
// module chunks = 0